import { PreviewPanelDetailRow } from "components/Atoms/details/PreviewPanelDetailRow";
import { useVisibleFreefieldCategoriesWithValues } from "components/Freefields/hooks";
import ReadonlyFreefieldValue from "components/Freefields/Readonly/ReadonlyFreefieldValue";
import React from "react";

interface PreviewPanelFreeFieldSectionsProps {
  categories: server.dto.FreeFieldCategorySmall[]
  freefieldValues: server.dto.FreeFieldValue[]
}

export const PreviewPanelFreeFieldSections = (props: PreviewPanelFreeFieldSectionsProps) => {
  const freeFieldCategoriesWithValues = useVisibleFreefieldCategoriesWithValues(props.categories, props.freefieldValues);
  const freeFieldCategoriesThatHaveVisibleValues = freeFieldCategoriesWithValues.filter(category => category.definitionWithValues.some(ffValue => ffValue.displayValue.hasVisibleValue));

  return <>
    {freeFieldCategoriesThatHaveVisibleValues.map((category) => {
      return <div key={category.freeFieldCategoryId} className="flex-column gap">
        <div><strong>{category.title}</strong></div>
        {category.definitionWithValues
          .filter(ffValue => ffValue.displayValue.hasVisibleValue)
          .map((ffValue) => {
            return <PreviewPanelDetailRow labelTop={ffValue.title} key={ffValue.freeFieldDefinitionId}>
              <ReadonlyFreefieldValue type={ffValue.type} displayValue={ffValue.displayValue} />
            </PreviewPanelDetailRow>
          })}
      </div>
    })}
  </>
}